import { Box } from "@mui/material";

import Map from "components/map/Map";
import Legends from "components/map/Legends";
import MapControl from "components/map/VegetationMapControl";
import SuitabilityControl from "./map/SuitabilityControl";

import { MapStateProvider } from "contexts/MapStateContext";
import { RunsProvider } from "contexts/RunsContext";
import { SimulationsProvider } from "contexts/SimulationsContext";

const ShareBody = () => {
  return (
    <RunsProvider>
      <SimulationsProvider>
        <MapStateProvider>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
            }}
          >
            <Map shareable={true} />
            <Legends />
            <SuitabilityControl shareable={true} />

            <MapControl />
          </Box>
        </MapStateProvider>
      </SimulationsProvider>
    </RunsProvider>
  );
};

export default ShareBody;
